import { render, staticRenderFns } from "./TradeFiles.vue?vue&type=template&id=4858aa8f&scoped=true&"
import script from "./TradeFiles.vue?vue&type=script&lang=js&"
export * from "./TradeFiles.vue?vue&type=script&lang=js&"
import style0 from "./TradeFiles.vue?vue&type=style&index=0&id=4858aa8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4858aa8f",
  null
  
)

export default component.exports